





















import Vue from 'vue';
export default Vue.extend( {
    name: "CardHeader",
    data: () => ({
        innerValue: ''
    }),
    props:{
        icon: String,
        title: String,
        search: String,
        isSearch: Boolean,
        value: String,
        buttonAdd: {
            default:true,
            type: Boolean
        }


    },
    methods: {
        onClickButton () {
            this.$emit('clicked')
        }
    },
    watch: {
        // Handles internal model changes.
        innerValue (newVal) {
            this.$emit('input', newVal);
        },
        // Handles external model changes.
        value (newVal) {
            this.innerValue = newVal;
        }
    },
    created () {
        if (this.value) {
            this.innerValue = this.value;
        }
    }
})
